import { Button } from '@mui/material';
import { GridFooter } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import i18next from 'i18next';
import { ActionConfirmationDialog } from './ActionConfirmationDialog';

// The existing execution callbacks stay unchanged; only their entry moves up.
export const FixturesAction = ({selectionModel,mode,handleCompileConfirm,handleEvaluateConfirm}) => {
  const [confirmOpen,setConfirmOpen]=useState(false);
  const count=selectionModel.length;
  const label=i18next.t(`help.dayWorkflow.${mode==='compile'?'compileAction':'evaluateAction'}`,{count});
  return <>
    <Button variant="contained" startIcon={<PlayArrowIcon/>} disabled={!count}
      onClick={()=>mode==='compile'?handleCompileConfirm():setConfirmOpen(true)}>{label}</Button>
    <ActionConfirmationDialog open={confirmOpen}
      title={i18next.t('help.dayWorkflow.evaluateTitle',{count})}
      paragraphs={[i18next.t('help.dayWorkflow.evaluateExplanation')]}
      confirmLabel={label} cancelLabel={i18next.t('help.compilePreview.cancel')}
      onCancel={()=>setConfirmOpen(false)}
      onConfirm={()=>{setConfirmOpen(false);handleEvaluateConfirm();}}/>
  </>;
};
export const FixturesFooter = () => <GridFooter/>;
